import { Configuration, LogLevel } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: `${globalThis._ENV_.REACT_APP_B2B_LOGIN_CLIENT_ID}`, // From Azure AD App Registration
    authority: `${globalThis._ENV_.REACT_APP_B2B_LOGIN_AUTHORITY}`, // For B2B, it's the Tenant ID from Azure AD
    redirectUri: `${globalThis._ENV_.REACT_APP_B2B_LOGIN_REDIRECT_URL}`, // Same as you set in Azure portal
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};
